import React, { useEffect, useState } from "react";
import AllButton from "../components/button/AllButton";
import DateCard from "../components/card/DateCard";
import HorizontalCard from "../components/card/HorizontalCard";
import NewsCard from "../components/card/NewsCard";
import FAQ from "../components/mainpage/FAQ";
import ImageCircle from "../components/mainpage/ImageCircle";
import SwiperContent from "../components/mainpage/SwiperContent";
import { HashLink as Link } from "react-router-hash-link";
import ServiceService from "../services/service";
import NewsService from "../services/news";
import FaqService from "../services/faq";
import SliderService from "../services/slider";
import ActivitiesService from "../services/activities";
import ArticleService from "../services/article";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

export default function Mainpage(props) {
  let [serviceData, setServiceData] = useState([]);
  let [newsData, setNewsData] = useState([]);
  let [faqData, setFaqData] = useState([]);
  let [sliderData, setSliderData] = useState(null);
  let [activitiesData, setActivitiesData] = useState([]);
  let [articleData, setArticleData] = useState([]);

  let { lang } = useParams();

  const history = useHistory();

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`${process.env.REACT_APP_WEB_URL}/th`, "_self");
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getServiceData();
    getNewsData();
    getFaqData();
    getSliderData();
    getActivitiesData();
    getArticleData();
  }, []);

  const getArticleData = async () => {
    try {
      let res = await ArticleService.getMainpageArticle();
      setArticleData(res);
    } catch {
      console.error();
    }
  };

  const getServiceData = async () => {
    try {
      let res = await ServiceService.getService();
      setServiceData(res);
    } catch {
      console.error();
    }
  };

  const getNewsData = async () => {
    try {
      let [res] = await NewsService.getMainpageNews({
        page: 1,
        pageSize: 3,
      });
      setNewsData(res);
    } catch {
      console.error();
    }
  };

  const getFaqData = async () => {
    try {
      let res = await FaqService.getFaq();
      setFaqData(res);
    } catch {
      console.error();
    }
  };

  const getSliderData = async () => {
    try {
      let res = await SliderService.getImage();
      setSliderData(res);
    } catch {
      console.error();
    }
  };

  const getActivitiesData = async () => {
    try {
      let res = await ActivitiesService.getMainpageActivities();
      setActivitiesData(res);
    } catch {
      console.error();
    }
  };

  return (
    <div id="mainpage" className="pb-[36px] pt-[135px] lg:pt-[0px]">
      {/* Swiper Content */}
      {sliderData ? (
        <SwiperContent data={sliderData} />
      ) : (
        <div className="h-[480px] bg-lightGray" />
      )}
      <div className="section">
        <div className="page-container">
          <div>
            {/* บริการของเรา */}
            <div className="mt-[60px]">
              <h1 className="text-[28px] xl:text-[32px] text-left">
                {lang === "th" ? "บริการของเรา" : "Service"}
              </h1>
              <div className="flex flex-wrap gap-[15px] items-center justify-around mt-[40px]">
                {serviceData &&
                  serviceData.map((item, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        if (item.link.href && item.link.href !== "-")
                          history.push(`/${lang}/service${item.link.href}`);
                      }}
                    >
                      <ImageCircle item={item} lang={lang} />
                    </div>
                  ))}
              </div>
            </div>

            {/* ข่าวสารล่าสุด และ กิจกรรม */}
            <div
              id="mainpage-activity"
              className="mt-[80px] grid grid-cols-4 gap-[50px]"
            >
              <div className="col-span-3 items-start">
                <div className="flex justify-between">
                  <h1 className="text-[28px] xl:text-[32px] text-left">
                    {lang === "th" ? "ข่าวสารล่าสุด" : "Lastest News"}
                  </h1>
                  <Link
                    className="flex justify-end"
                    to={`/${lang}/newsAndActivity/news`}
                  >
                    <AllButton lang={lang} />
                  </Link>
                </div>
                <div className="mt-[22px]">
                  {newsData && newsData[0] && (
                    <NewsCard
                      data={newsData[0]}
                      page="newsAndActivity/news"
                      lang={lang}
                    />
                  )}
                </div>

                <div
                  id="mainpage-activity-section"
                  className="grid grid-cols-2 gap-[18px] mt-[14px]"
                >
                  {newsData &&
                    newsData
                      .slice(1, 3)
                      .map((item, i) => (
                        <HorizontalCard
                          size="small"
                          data={item}
                          key={i}
                          page="newsAndActivity/news"
                          lang={lang}
                        />
                      ))}
                </div>
              </div>
              <div className="col-span-1 items-start">
                <h1 className="text-[28px] xl:text-[32px] text-left">
                  {lang === "th" ? "กิจกรรม" : "Activity"}
                </h1>
                <div className="flex flex-col gap-[14px] mt-[22px]">
                  {activitiesData &&
                    activitiesData.map((item, i) => (
                      <DateCard
                        key={i}
                        data={item}
                        hasBg={item && item.image[0] ? true : false}
                        page="newsAndActivity/activity"
                        lang={lang}
                      />
                    ))}
                  <Link
                    className="flex justify-end"
                    to={`/${lang}/newsAndActivity/activity`}
                  >
                    <AllButton lang={lang} />
                  </Link>
                </div>
              </div>
            </div>

            {/* FAQ และ Health Update */}
            <div
              id="mainpage-faq"
              className="mt-[57px] grid grid-cols-2 gap-[28px]"
            >
              <div className="col-span-1">
                <h1 className="text-[28px] xl:text-[32px] text-left">FAQ</h1>
                <div className="mt-[20px]">
                  <FAQ data={faqData} lang={lang} />
                </div>
              </div>
              <div className="col-span-1">
                <h1 className="text-[28px] xl:text-[32px] text-left">
                  <span className="font-bold">Health</span> UPDATE
                </h1>
                <div className="mt-[20px] flex gap-[17px]">
                  {articleData &&
                    articleData.map((item, i) => (
                      <NewsCard
                        key={i}
                        data={item}
                        lineClamp={2}
                        hideIcon={true}
                        lang={lang}
                        page={"article"}
                      />
                    ))}
                </div>
                <div
                  className="flex justify-end mt-[16px]"
                  onClick={() => {
                    history.push(`/${lang}/article`);
                  }}
                >
                  <AllButton lang={lang} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
